module.exports = __webpack_public_path__ + "static/media/whiteCrown.0cea89c4.svg";